import styled from 'styled-components';

export const StyledPlayerLevelMultiplier = styled.div`
  max-width: 400px;
  position: relative;
  display: flex;
  font-family: 'Lemon Milk';

  @media (max-width: $tablet) {
    max-width: 606px;
  }

  .image {
    max-width: 100%;
  }

  .bottom-text-container {
    position: absolute;
    display: flex;
    justify-content: center;
    width: 85px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 22%;
    height: 23%;

    .bottom-text {
      width: 100%;
      text-align: center;
      color: white;
      font-weight: 400;
      margin: auto 0;
    }
  }

  .left-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 50%;
    width: 30%;
    transform: translateY(-50%);
    left: 9px;
    text-align: center;
    font-style: normal;
    color: white;

    .left-text {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 17px;
      font-weight: 500;
    }

    .left-value {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
    }
  }
`;
